import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {action, observable, reaction, runInAction} from 'mobx';
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack';

import debounce from 'lodash/debounce';
import WhiteBoardWrapper from '../../containers/studio/whiteboard/WhiteBoardWrapper';
import './style.scss';
import {ProjectAssetsType} from "../../constants/enums";

@inject('projectStore', 'wizardStore')
@observer
class PDFViewer extends Component {
    @observable numPages = 0;
    @observable currentPage = 0;
    @observable pagesLoaded = 1;
    @observable height = null;

    @observable pageRef = null;
    @observable actualWidth = null;
    @observable actualHeight = null;
    @observable mountCanvas = true; // ugly hack to force canvas to refresh
    @observable dimensionTimestamp = Date.now();

    prevWidth = null;
    ratio = 1;

    setRef = (ref) => {
        this.container = ref;
        // if (this.container) {
        //     this.container.addEventListener('scroll', this.scroll);
        // }
    }


    componentDidMount() {
        // setting width at initial
        this.setWidth();
        // event listener when window is resized
        window.addEventListener('resize', this.setWidth);

        this.listner1 = reaction(
            () => this.props.url,
            (url) => {
                if (url) {
                    runInAction(() => {
                        this.pagesLoaded = 1;
                        this.numPages = 0;
                    })
                }
            },
            {});

        this.listner2 = reaction(
            () => this.props.page,
            (page) => {
                if (page > -1) {
                    runInAction(() => {
                        this.mountCanvas = false;
                        setImmediate(() => {
                            runInAction(() => {
                                this.mountCanvas = true;
                            })
                        })
                    })
                }
            },
            {});

        this.listner3 = reaction(
            () => this.props.wizardStore.currentStepType,
            (type) => {
                if (type === ProjectAssetsType.Notation) {
                    if (this.pageRef) {
                        setTimeout(action(() => {
                            if (this.pageRef.clientHeight > 50) {
                                this.actualHeight = this.pageRef.clientHeight;
                                this.actualWidth = this.pageRef.clientWidth;
                            }
                        }))
                    }
                }
            }
        )
    }

    componentDidCatch(err, info) {
        console.log(err);
    }


    // @action scroll = (e) => {
    //     if (this.numPages > 0 && this.height * this.pagesLoaded - e.target.scrollTop <= this.container.offsetHeight + 100) {
    //         this.fetching = true;
    //         this.pagesLoaded++;
    //     }
    //     this.currentPage = Math.floor(e.target.scrollTop / this.height);
    //     console.log(e.target.scrollTop / this.height, this.height, e.target.scrollTop, this.currentPage);
    // };

    componentWillUnmount() {
        window.removeEventListener('resize', this.setWidth);
        // if (this.container) {
        //     this.container.removeEventListener('scroll', this.debounceSetHeight);
        // }
        if (this.listner1) {
            this.listner1();
        }
        if (this.listner2) {
            this.listner2();
        }
        if (this.listner3) {
            this.listner3();
        }
    }

    setWidth = debounce(action(() => {
        if (this.container) {
            if (this.container.offsetWidth !== this.prevWidth) {
                this.dimensionTimestamp = Date.now();
                this.prevWidth = this.container.offsetWidth;
            }
            this.width = Math.min(this.container.offsetWidth || window.innerWidth, 1024);
        }

        if (this.pageRef) {
            if (this.pageRef.clientHeight > 50) {
                this.actualHeight = this.pageRef.clientHeight;
                this.actualWidth = this.pageRef.clientWidth;
            }
        }
    }), 500);

    @action setPageRef = (ref) => {
        if (ref) {
            this.pageRef = ref;
            this.setWidth();
        }
    }

    @action
    onDocumentLoadSuccess = (pdf) => {
        const {projectStore, id} = this.props;
        this.numPages = pdf.numPages;
        this.props.file.numPages = this.numPages;
        projectStore.updateNumPages(id, this.numPages)
        this.props.onLoad(pdf.numPages);
    }

    onDocumentError = (err) => {
        console.log(err);
        this.props.onError();
    }


    cancelCanvas = () => {
        const {projectStore, cancelCanvas} = this.props;
        if (cancelCanvas) {
            cancelCanvas();
            return;
        }
        projectStore.editNotationCanvas(false);
    };


    render() {
        const {id, url, isCanvasEditable, rotate, canvas = [{}], page, isLoading} = this.props;

        const pageCanvas = canvas[page] || {};

        const areWeOffsettingParent = this.container?.offsetWidth < this.actualWidth * pageCanvas.scale;

        const style = {
            transform: `scale(${pageCanvas.scale})`,
            transformOrigin: areWeOffsettingParent ? '0 0' : '50% 0',
        };

        const showCanvas = !isLoading;
        return (
            <div className="pdf-doc" ref={this.setRef}>
                <Document rotate={rotate === 0 ? null : rotate}
                          file={url}
                          onLoadSuccess={this.onDocumentLoadSuccess}
                          onLoadError={this.onDocumentError}
                          loading={''}>
                    <div className="page-wrapper" style={style}>
                        <Page
                            className="page-pdf"
                            key={`page_${page + 1}_${this.dimensionTimestamp}`}
                            pageNumber={page + 1}
                            width={this.width}
                            scale={1}
                            loading={'Loading...'}
                            inputRef={this.setPageRef}

                        />
                    </div>
                </Document>
                {this.mountCanvas && showCanvas && this.actualHeight > 50 && <WhiteBoardWrapper
                    width={this.width}
                    height={this.actualHeight}
                    isNotation={true}
                    canvas={pageCanvas}
                    cancelCanvas={this.cancelCanvas}
                    isCanvasEditable={isCanvasEditable}
                    page={page}
                    id={id}
                />}
            </div>
        );
    }
}

PDFViewer.propTypes = {
    url: PropTypes.string,
};

export default PDFViewer;
